import { defineMessages } from 'react-intl';

export default defineMessages({
  reportLabel: 'Report',
  reportRequiredError: 'Report is required.',
  createReport: 'Create a new report',
  reportSelectPlaceholder: 'Select or create a report',
  reportSelectAddTooltip: 'Press Enter to add or Esc to cancel.',
  commentLabel: 'Comment',
  commentPlaceholder: 'Add a comment explaining the chart',
  reachedReportLimit: 'You have reached the number of reports your license allows. You can only select reports with content from this data source. You can upgrade your license if you want to create more reports.',
});
